import styled from 'styled-components';

export const Wrapper = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
`;

export const List = styled.ul`
  list-style-type: none;
  margin-block-start: 0px;
  margin-block-end: 0px;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  padding-inline-start: 0px;
  display: flex;
  flex-direction: column;
`;

export const ListItem = styled.li``;
